<template>
    <div class="loginBG">
      <div id="banners">
        <div class="banner banner1"></div>
        <!-- <div class="banner banner2"></div>
        <div class="banner banner3"></div> -->
      </div>
      <div class="parasso-top para-widget-actions">
        <div class="parasso-theme para-widget-actions">
          <img :src="require('assetsImg/form-logo1.png')" />
        </div>
        <div class="parasso-top__right-content">
          <div class="parasso-card--language">
            <span v-for="item in langConfig" :key="item.type" @click="toggleLang(item.type)" class="language-item" :class="{ active: item.text == curLang }" :data-language="item.type">{{item.text}}</span>
          </div>
        </div>
      </div>
      <div ref="container" class="login-container">
        <div class="login-content">
          <div class="login-card">
            <!-- logo -->
            <div class="logo-img">
              <span>华硕电商OMS</span>
              <!-- <img :src="require('assetsImg/form-logo1.png')" /> -->
            </div>
            <!-- tabs -->
            <div class="loginTabs" v-if="isEnableLoginPro">
              <div class="tab" @click="toggleTab('pwd')">
                <span>{{ t('密码登录') }}</span>
              </div>
              <div class="tab" @click="toggleTab('phone')">
                <span>{{ t('验证码登录') }}</span>
              </div>
            </div>
            <!-- 欢迎登录 -->
            <div class="title">{{ t('欢迎登录') }}</div>
            <!-- 表单 -->
            <CoreL />
            <div v-if="nowType == 'phone'" class="emergencyLogin" @click="toggleTab('pwd')">{{t('应急登录')}}<Icon type="ios-arrow-round-forward" /></div>
            <div v-else class="emergencyLogin" @click="toggleTab('phone')">{{t('返回短信验证')}}<Icon type="ios-arrow-round-back" /></div>
            <!-- <R3Login :loginSucCbk="loginSucCbk" /> -->
            <!-- bg -->
            <!-- <span class="login-bg-img">
              <img :src="require('assetsImg/login-bg-img-180.png')" />
            </span> -->
          </div>
        </div>
      </div>
      <div class="copyRight">
        <a href="http://beian.miit.gov.cn" target="_blank">©️ 2018-2024 Burgeon Co. Ltd., All Rights Reserved.</a>
      </div>
    </div>
  <!-- </div> -->
</template>

<script>
import R3 from "@syman/burgeon-r3";
import service from '@/service/index';
import CoreL from './Login/LoginCore.vue'

const langConfig = [
  {
    type: "zh",
    text: "中文",
  },
  {
    type: "en",
    text: "English",
  },
  /* {
    type: "ja",
    text: "日本語",
  }, */
];
export default {
  name: "Login",
  components: {
    CoreL,
    R3Login: R3.components.Login,

  },
  data () {
    return {
      nowType: 'phone',
      langConfig,
      curLang: "", // 当前语言
      isEnableLoginPro: false, // 是否开启手机验证码登录
      timer: null
    };
  },
  async created () {
    this.isEnableLoginPro = !!window.ProjectConfig.enableLoginPro // 置于await后会导致取值错误
    const browseLan = localStorage.getItem("locale") || "zh";
    await VoerkaI18n.change(browseLan)
    vm._i18n.locale = browseLan
    $i18n.locale = browseLan;
    this.curLang = langConfig.find((it) => it.type == browseLan).text;
    this.$store.commit('customize/setCurLang', browseLan);
  },
  mounted () {
    this.isEnableLoginPro && this.initTab(false); // 默认验证码登录，false:账密, true:手机号
    setTimeout(() => {
      this.initDom();
      let node = document.createElement('span')
      node.setAttribute('class', 'tabnav-highlight')
      document.querySelector('.loginTabs').appendChild(node)
    }, 100)
    this.resetCSS(6000)
  },
  methods: {
    G() { return document.getElementById('banners')},
    resetCSS(speed) {
      let ts = this.G().getElementsByTagName('div');//获取容器内需要轮流显示的子元素：这里是 div
      let k=0
      this.timer = setInterval(() => {//定义时间控制器
        for(let i=0; i<ts.length; i++){
          ts[i].style.display='none';
        }//先隐藏全部，此处效率降低，可以考虑不用循环
        ts[k].style.display='';//显示需要显示的
        if(k>ts.length-2){
          k=0;
        }else{
          k++;
        }
      },speed)
    },
    initDom () {
      let isPhone = document.querySelector(".divErCode");
      let account = document.querySelector(".divAccount");
      let code = document.querySelector(".divCode");
      let inputNodes = document.querySelectorAll(".loginCore .container input");
      let r3ChangeLan = document.querySelectorAll(".loginCore .changeLang");
      r3ChangeLan[0] && (r3ChangeLan[0].style.display = "none");
      code && code.setAttribute("data-code", t('验证码'));
      if (isPhone) {
        // 验证码登录
        account.setAttribute(
          "data-phone",
          t('手机号')
        );
        inputNodes[0].setAttribute("placeholder", t('请输入手机号'));
        inputNodes[1].setAttribute("placeholder", t('请输入短信验证码'));
        const lastPhone = window.localStorage.getItem('lastLoginPhone');
        if (lastPhone && inputNodes[0] && !inputNodes[0].value) {
          inputNodes[0].value = lastPhone;
        }
      } else {
        // 密码登录
        let pwd = document.querySelector(".divMima");
        account.setAttribute("data-account", t('账号'));
        pwd.setAttribute("data-pwd", t('密码'));
        inputNodes[0].setAttribute("placeholder", t('请输入用户名'));
        inputNodes[1].setAttribute("placeholder", t('请输入密码'));
        /* if (this.isEnableLoginPro) {
          inputNodes[2].setAttribute(
            "placeholder",
            t('请输入验证码')
          ); // 请输入验证码
        } */
      }
      /* let loginBtn = document.getElementById("btn");
      loginBtn.innerHTML = `${t(
        "登录"
      )} <img src="${require("assetsImg/arrow-right.png")}" />`; */

    },
    initTab (isPhone) {
      let nodes = document.querySelectorAll(".tab");
      nodes[Number(isPhone)].classList.add("active");
      nodes[Number(!isPhone)].classList.remove("active");
    },
    toggleTab (type) {
      this.nowType = type
      if (
        (type == "pwd" && document.querySelector(".loginPro")) ||
        (type == "phone" && document.querySelector(".divErCode"))
      )
        return;
      document.getElementsByClassName("toggle")[0].click();
      this.$nextTick(() => {
        this.initDom();
      });
      this.initTab(type == "phone");
    },
    async toggleLang (lang) {
      const _this = this;
      this.curLang = langConfig.find((it) => it.type == lang).text;
      await $i18n.lang(lang)
      this.initDom();
      // this.$Message.success(message);
    },
    /**
     * 切换语言
     * 走框架登录成功前的回调loginSucCbk，返回true就继续走，false就拦截
     */
    async loginSucCbk () {
      const pa = new FormData();
      pa.append('language', localStorage.getItem("locale") || 'zh');
      console.log(service.common);
      const { status, data } = await service.common.langSwitcher(pa)
      return status === 200 && data.code === 0
    },
  },
  destroyed() {
    this.timer && clearInterval(this.timer);
  }
};
</script>
<style lang="less">
.emergencyLogin {
  cursor: pointer;
  position: absolute;
  bottom: 62px;
  right: 4px;
  font-size: 14px;
  color: #002C57;
}
// 切换动画
.loginTabs {
  visibility: hidden;
  height: 0 !important;
  .tab {
    &:nth-child(1) {
      &.active~.tabnav-highlight {
        transform: translateX(0%);
      }
    }
    &:nth-child(2) {
      &.active~.tabnav-highlight {
        transform: translateX(100%);
      }
    }
  }
  .tabnav-highlight {
    transition: .2s ease-out;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    background: #002C57;
    border-radius: 25px;
  }
}
</style>

<style lang="less" scoped>
@import 'omsTheme/index.less';
#banners {
  display: block;
  width: 100%;
  height: 100%;
  .banner {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
.banner1 {
  background: url('/src/assets/img/hsBg.jpg') no-repeat;
  // background: url('https://www.burgeon.cn/static/yipeng/images/banner2023.jpg') no-repeat;
  background-size: 100% 100%;
}
.banner2 {
  background: url('https://www.burgeon.cn/static/yipeng/images/03banner.jpg') center center no-repeat;
  background-size: 100% 100%;
}
.banner3 {
  background: url('https://www.burgeon.cn/static/yipeng/images/01banner.jpg') no-repeat;
  background-size: 100% 100%;
}
.loginBG {
  // background: url("/src/assets/img/login-bg-180.png") no-repeat;
  // background-size: cover;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  .copyRight  {
    position: fixed;
    bottom: 2vh;
    a {
      // color: rgb(81, 90, 110);
      color: #002C57;
    }
  }
  // 国际化
  .i18nDom {
    z-index: 999;
    position: absolute;
    top: 16px;
    right: 16px;
    border: 1px solid #fff;
    padding: 2px 0;
    border-radius: 5px;
    width: 100px;
    text-align: center;
    .ark-dropdown {
      min-width: 100px;
    }
    button {
      height: 24px;
      width: 60px;
      border-radius: 2px;
      border: 1px solid @button-border;
      color: @button-border;
      background-color: @button-bg-font;
      margin-right: 20px;
    }
    span {
      font-size: 16px;
      text-align: left;
    }
    /deep/ .ark-dropdown-rel a {
      color: #fff;
      display: inline-block;
      line-height: 20px;
    }
  }
  /*整块内容*/
  .login-container {
    /* width: 1024px;
    height: 480px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 17px;
    background: url("~assetsImg/login-form-bg-180.png") left no-repeat #fff;
    background-size: auto 100%; */

    // height: calc(100% - 64px);
    // width: 60%;
    height: 100%;
    width: 400px;
    position: absolute;
    // top: 64px;
    top: 0;
    bottom: 0;
    // left: 0;
    left: 140px;
  }
  .loginTabs {
    display: flex;
    font-weight: 600;
    font-size: 16px;
    text-align: center;
    color: #c3c6d2;
    cursor: pointer;
    // margin-bottom: 26px;

    position: relative;
    width: 100%;
    height: 50px;
    border-radius: 25px;
    overflow: hidden;
    border: 1px solid #F7F6F9;
    .tab {
      width: 50%;
      &.active {
        background: none;
      }
      span {
        position: relative;
        z-index: 1;
        color: #a1a1a6;
        line-height: 46px;
      }
      &.active span {
        color: #ffffff;
        pointer-events: none;
        transition: color .2s ease-out;
      }
    }
  }
  .login-content {
    width: 20.8%;
    /* width: 50%;
    text-align: center; */
    min-width: 400px;
    height: 100%;
    /* padding-bottom: 40px;
    position: absolute;
    margin-left: 50%;
    top: 50%;
    transform: translateY(-50%); */
    padding: 0 40px;
    margin-left: 50%;
    float: right;
    border-radius: 0;
    margin: 0;
    background: rgba(255, 255, 255, .2);
    box-shadow: -5px -5px 250px 0 rgba(255, 255, 255, 0.02) inset;
    backdrop-filter: blur(10px);
    display: grid;
    align-content: center;

    .login-card {
      position: relative;
      width: 100% !important;
      height: 100% !important;
      margin: 0;
      background: none;
      border-radius: 0;
      border: 1px solid rgba(0,0,0,0);
      box-shadow: none;
      transform: scale(0.9);
    }

    /*头部区域*/
    .logo-img {
      font-size: 40px;
      font-weight: bold;
      margin-bottom: 35px;
      // display: inline-block;
      // margin-top: 50px;
      // margin-bottom: 0;
      text-align: center;
      // width: 240px;
      // height: 80px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title {
      cursor: default;
      text-align: center;
      font-size: 20px;
      letter-spacing: 2px;
      font-weight: 600;
      // color: #6d6e71;
      margin: 10px 0 24px 0;
    }
    .login-bg-img {
      width: 137px;
      position: absolute;
      right: -35px;
      bottom: -66px;
      img {
        width: 100%;
      }
    }
    // login登陆
    .loginCore {
      //设置样式
      width: 100%;
      height: auto;
      position: relative;
      /deep/ .container {
        // width: 340px;
        width: 100%;
        margin: 0 auto;
        height: auto;
        position: inherit;
        background-color: transparent;
        .icon {
          width: 20px;
          height: 20px;
          left: 19px;
          top: 15px;
        }
        // 登录框
        & > div:first-child {
          text-align: left;
          .titleTOP,
          .divToggle {
            display: none;
          }
          .divGdCode,
          .divAccount,
          .divMima,
          .divCode,
          .codeimg {
            position: relative;
            top: auto;
            left: auto;
            width: 100%;
          }
          //input
          .gdCode,
          .username,
          .password,
          .pwd {
            font-size: 16px;
            border: 1px solid #dbdde8 !important;
            background: #fff;
            // text-align: right;
            padding-left: 58px;
            margin-bottom: 26px;
            border-radius: 10000px !important;
            height: 50px !important;
            overflow: hidden;
            width: 100%;
            // height: 100%;

            &::-webkit-input-placeholder,
            &::-webkit-input-placeholder,
            &::-moz-input-placeholder,
            &::-ms-input-placeholder {
              color: #c3c6d2;
              font-size: 12px;
            }
            &:-webkit-autofill {
              -webkit-text-fill-color: #292f43;
              -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
              background-color: transparent;
              background-image: none;
              transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
            }
          }
          // 验证码长度
          /* .code.pwd {
            width: calc(100% - 116px);
          } */
          // codeimg
          .codeimg {
            position: absolute;
            right: 0;
            bottom: 62px;
            width: 100px;
            border-color: #dcdee2;
          }
          .erCodeBtn {
            /* margin-bottom: 3px;
            margin-left: 0;
            border-radius: 4px;
            vertical-align: top;
            margin-left: 16px; */
            margin-right: 0;
            // width: 100px;

            position: absolute;
            right: 0;
            border-radius: 0 10000px 10000px 0 !important;
            background: rgb(238 237 241);
            height: 50px !important;
            span {
              font-size: 14px;
            }
            &:hover {
              opacity: 0.9;
              // border-color: @base-color;
              // color: @base-color;
            }
          }
          // 定位图标文字
          > div::before {
            position: absolute;
            left: 0;
            top: 0;
            display: inline-block;
            width: 80px;
            height: 38px;
            line-height: 38px;
            font-size: 12px;
            padding-left: 16px;
            #bundle > .points;
          }
          .divAccount:before {
            // content: attr(data-account); // 账号
            // color: #313c52;
          }
          .divCode {
            font-size: 0;
            /* &:before {
              content: attr(data-code); // 验证码
              color: #313c52;
            } */
            display: inline-block;
            vertical-align: top;
          }
          /* .divMima:before {
            content: attr(data-pwd); // 密码
            color: #313c52;
          } */
          .divMima, .divCode {
            input {
              // margin-bottom: 47px;
            }
          }
        }
        // 登录按钮
        & > div:nth-child(2) {
          .btn {
            position: inherit;
            margin: 0;
            width: 100%;
            // line-height: 38px;
            background: #5461b8;
            border-radius: 4px;
            font-size: 16px;
            font-weight: bold;
            box-shadow: 0px 6px 20px 0px rgba(69, 96, 171, 0.31);
            border: none;
            img {
              width: 20px;
              height: 20px;
              vertical-align: text-bottom;
            }
          }
          button.btn, button.btn span {
            margin-top: 24px;
            background: #002C57 !important;
            font-size: 18px;
            box-shadow: 0 4px 4px 0 #1b48c433;
            border-radius: 10000px !important;
            height: 50px !important;
            font-weight: 700;
          }
        }
      }
      /deep/ .divErCode {
        .divAccount:before {
          // content: attr(data-phone) !important; // 手机号
        }
        .divAccount,
        .divCode {
          &::before {
            padding-left: 16px !important;
          }
         /*  img {
            display: none;
          } */
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.para-widget-actions {
  border: 1px solid rgba(0,0,0,0);
  position: relative;
}
.parasso-top {
  display: none;

  width: 100%;
  height: 64px;
  background: #ffffff;
  padding: 0 40px;
  position: absolute !important;
  top: 0;
  left: 0;
  .parasso-theme {
    float: left;
    padding: 0;
    height: 100%;
    min-height: 60px;
    img {
      height: 115%;
    }
  }
  .parasso-top__right-content {
    float: right;
    .parasso-card--language {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      right: 30px;
      color: #999999;
      font-weight: 400;
      font-size: 0;
    }
    & > div {
      display: inline-block;
    }
    .language-item {
      cursor: pointer;
      display: inline-block;
      padding: 0;
      line-height: 28px;
      background: #F7F6F9;
      color: #B4B6C2;
      font-size: 12px;
      min-width: 70px;
      text-align: center;
      &:first-child {
        border-radius: 100px 0 0 100px;
      }
      &:last-child {
        border-radius: 0 100px 100px 0;
      }
      &.active {
        background: #002C57;
        color: #ffffff;
      }
    }
  }
}
</style>
